import Box from "@mui/material/Box";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

import { useTranslation } from "react-i18next";
import { AsbestosForm } from "./SeparatedForms/AsbestosForm/AsbestosForm";
// import { EdificationForm } from "./SeparatedForms/EdificationForm";
import { AttachmentsForm } from "./SeparatedForms/ImagesForm/ImagesForm";
import { Tab, Tabs, Tooltip } from "@mui/material";
import { EdificationForm } from "./SeparatedForms/EdificationForm/EdificationForm";
import { Confirm } from "notiflix";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  create_preliminar_element,
  delete_preliminar_element,
  update_preliminar_element,
} from "../../../../../api/layers/ApiLayerAsbestos";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import AppContext from "../../../../Contexts/AppContext";
import {
  findLayerById,
  findLayerByUuid,
} from "../../../../../services/MapCore/LayerGroupService";
import { toast } from "react-toastify";
import { Geometry } from "ol/geom";
import { translations } from "../../../../../utils/i18n/translations";
import { UndoButton } from "../../../../../schemes/layer_groups/asbestos/AsbestosLayerGroup";
import {
  exitEditMode,
  resetDrawingSession,
} from "../../../../../services/MapCore/MapService";

const stepComponents = {
  asbestos: AsbestosForm,
  edification: EdificationForm,
  attachments: AttachmentsForm,
};

function isEditableElement(el) {
  const node = el;
  if (!node) return false;
  if (node.isContentEditable) return true;
  const tag = node.tagName ? node.tagName.toLowerCase() : "";
  return tag === "input" || tag === "textarea" || tag === "select";
}

function getShortcutLabel(key) {
  const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform);
  return isMac ? `⌘${key.toUpperCase()}` : `Ctrl+${key.toUpperCase()}`;
}

export const FeatureForm = forwardRef(({ content, onClose }, ref) => {
  const {
    mapInstanceRef,
    editedGeometry,
    setEditedGeometry,
    layersGroupsRef,
    modeOptions,
    setModeOptions,
    resetModeOptions,
    project,
  } = useContext(AppContext);
  const map = mapInstanceRef.current;
  const layersGroups = layersGroupsRef?.current;
  const { t, i18n } = useTranslation("main");
  const [activeStep, setActiveStep] = useState(0);
  const isMobile = window.innerWidth < 960;

  const asbestos_view =
    typeof content[0]?.view?.find === "function" &&
    content[0]?.view.find((el) => el[0].layer_type === "AMIANTO_CENSO")?.[0];

  const properties = asbestos_view?.properties;

  const [formValues, setFormValues] = useState({
    ...properties,
  });

  const steps = Object.keys(stepComponents);

  const StepComponent = stepComponents[steps[activeStep]];

  const hasFormChanged =
    JSON.stringify(properties) !== JSON.stringify(formValues);

  const handleChange = (key) => (eventOrValue) => {
    setFormValues((prev) => {
      let newValue;

      // 1️⃣ Si el valor es un objeto Date, lo convertimos a "YYYY-MM-DDZ"
      if (eventOrValue instanceof Date) {
        const year = eventOrValue.getFullYear();
        const month = String(eventOrValue.getMonth() + 1).padStart(2, "0"); // Meses en JS van de 0 a 11
        const day = String(eventOrValue.getDate()).padStart(2, "0");
        newValue = `${year}-${month}-${day}`; // Formato final con "Z"
      }
      // 2️⃣ Si el valor es un string terminado en "Z", lo limpiamos antes de mostrarlo
      else if (typeof eventOrValue === "string" && eventOrValue.endsWith("Z")) {
        newValue = eventOrValue.slice(0, -1); // Eliminamos la "Z"
      }
      // 3️⃣ Para otros valores (texto, checkbox, etc.)
      else {
        newValue = eventOrValue.target
          ? eventOrValue.target.type === "checkbox"
            ? eventOrValue.target.checked
            : eventOrValue.target.value
          : eventOrValue;
      }

      return {
        ...prev,
        [key]: newValue,
        ...((key === "risk_simplify_type" || key === "risk_form_value") && {
          risk_final_value: newValue,
        }),
      };
    });
  };

  const totalSteps = () => steps.length;
  const isLastStep = () => activeStep === totalSteps() - 1;

  const handleNext = () => {
    if (!isLastStep()) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleSave = async () => {
    if (modeOptions.ADD_POLYGON.length > 0) {
      const toast_id_creating_new_element = toast.info(
        `${translations[i18n.language].creating_new_element}...`,
        {
          // position: "top-right",
          hideProgressBar: false,
          loading: true,
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );

      try {
        // const data = {};
        const geom = {
          type: "Feature",
          geometry: {
            coordinates: editedGeometry,
            type: "Polygon",
            // type: "MultiPolygon",
          },
        };

        // data["geometry"] = geom;
        // data["inspection_type"] = "PRELIMINAR";
        // data["element_type"] = "BAJANTE";

        const newElement = await create_preliminar_element(
          modeOptions.ADD_POLYGON[0],
          { ...formValues, geometry: geom }
          // { ...formValues, geometry: editedGeometry }
        );

        // una vez creado actualizamos
        // const layer_g = findLayerById(map, this.id);
        const layer_g = findLayerByUuid(map, modeOptions.ADD_POLYGON[0]);

        layer_g.getSource()?.updateParams({ t: Date.now() });

        toast.update(toast_id_creating_new_element, {
          render: translations[i18n.language].element_created_successfully,
          type: "success",
          isLoading: false,
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          closeButton: (
            <UndoButton
              item_uuid={newElement.uuid}
              layerUuid={modeOptions.ADD_POLYGON[0]}
              map={map}
            />
          ),
        });

        setEditedGeometry(null);
        // exitEditMode({ map: mapInstanceRef.current });
        // setModeOptions((prev) => ({ ...prev, ADD_POLYGON: [] }));

        // resetModeOptions();
      } catch (err) {
        console.error("Error en la petición", err);
        toast.update(toast_id_creating_new_element, {
          render: translations[i18n.language].element_creating_error,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      }
    } else {
      const toast_id_updating_element = toast.loading(
        `${t("updating_element")}...`,
        {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
      await update_preliminar_element(properties.uuid, properties.layer_uuid, {
        ...formValues,
        building_creation_date: properties?.building_creation_date?.replace(
          /Z$/,
          ""
        ),
        building_refurbishing_date:
          properties?.building_refurbishing_date?.replace(/Z$/, ""),
        ...(editedGeometry && { geometry: editedGeometry }),
      });

      let wmsLayer = null;

      for (const layerGroup of layersGroups) {
        const layer = layerGroup.layers.find(
          (layer) => layer.layer_data?.layer_type === "AMIANTO_CENSO"
        );
        if (layer) {
          wmsLayer = layer.layer; // Obtenemos la capa de OpenLayers
          break;
        }
      }

      // 2️⃣ SI ENCONTRAMOS LA CAPA, FORZAR LA RECARGA DEL WMS
      if (wmsLayer) {
        wmsLayer.getSource()?.updateParams({ t: Date.now() }); // Forzar recarga de la capa
      }

      // 4️⃣ ELIMINAR EL FEATURE RESALTADO (HIGHLIGHT)
      const highlightLayer = map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "highlightLayer");

      if (highlightLayer) {
        highlightLayer.getSource().clear(); // Eliminar todos los features resaltados
        map.removeLayer(highlightLayer); // Opcional: remover la capa si ya no se usa
      }
      toast.update(toast_id_updating_element, {
        render: t("element_updated_successfully"),
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });
    }
    onClose();
  };

  const handleConfirmSave = () => {
    if (hasFormChanged || editedGeometry) {
      Confirm.show(
        t("save_changes_title"),
        t("save_changes_body"),
        t("yes"),
        t("no"),
        handleSave,
        () => {},
        {}
      );
    }
  };

  const saveKey = "g";

  useEffect(() => {
    const onKeyDown = (e) => {
      const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform);
      const ctrlLike = isMac ? e.metaKey : e.ctrlKey;
      const keyIsS = (e.key || "").toLowerCase() === saveKey;

      if (!ctrlLike || !keyIsS) return;

      const canSave =
        isValidPolygonForProject(editedGeometry) &&
        (hasFormChanged || !!editedGeometry);

      if (canSave) {
        e.preventDefault();
        handleSave();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [handleSave, editedGeometry, hasFormChanged]);

  const handleDelete = () => {
    Confirm.show(
      t("delete_element_title"),
      t("delete_element_body"),
      t("yes"),
      t("no"),

      async () => {
        const toast_id_deleting_element = toast.loading(
          `${t("deleting_element")}...`,
          {
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );

        await delete_preliminar_element(properties.uuid, properties.layer_uuid);

        const layer_uuid = findLayerByUuid(map, properties.layer_uuid);

        layer_uuid?.getSource()?.updateParams({ t: Date.now() });

        toast.update(toast_id_deleting_element, {
          render: t("element_deleted_successfully"),
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });

        onClose();
      },
      () => {},
      {}
    );
  };

  const deleteKey = "d";

  useEffect(() => {
    const onKeyDown = (e) => {
      // Ignore when focused on editable fields
      if (isEditableElement(e.target)) return;

      const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform);
      const ctrlLike = isMac ? e.metaKey : e.ctrlKey;
      const keyIsD = (e.key || "").toLowerCase() === deleteKey;

      // Only trigger when delete button is actually relevant/visible
      const canDelete = modeOptions.ADD_POLYGON.length === 0;

      if (ctrlLike && keyIsD && !e.shiftKey && !e.altKey && canDelete) {
        // Prevent browser default (bookmarking on Ctrl/⌘+D)
        e.preventDefault();
        handleDelete();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [handleDelete, modeOptions.ADD_POLYGON.length]);

  const handleDiscard = () => {
    if (hasFormChanged || editedGeometry) {
      Confirm.show(
        t("discard_changes_title"),
        t("discard_changes_body"),
        t("yes"),
        t("no"),

        () => {
          resetDrawingSession({ map, setEditedGeometry });
          setEditedGeometry(null);
          // exitEditMode({ map: mapInstanceRef.current });
          // setModeOptions((prev) => ({ ...prev, ADD_POLYGON: [] }));
          onClose();
        },
        () => {},
        {}
      );
    } else {
      onClose();
    }
  };

  useImperativeHandle(ref, () => ({
    function: () => handleDiscard(), // Evita la recursión
  }));

  return (
    <Box
      sx={{
        width: "100%",
        padding: "1rem",
        paddingBottom: "0",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Tabs
        variant="scrollable"
        value={activeStep}
        onChange={(_, newValue) => handleStep(newValue)()}
      >
        {steps.map((label, index) => (
          <Tab key={label} label={t(label)} value={index} />
        ))}
      </Tabs>
      <Box
        sx={{
          flexGrow: 1,
          overflow: "hidden",
          borderRadius: "8px",
          border: "1px solid lightgrey",
          borderTop: "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            p: 2,
            flexGrow: 1,
            // height: "100%",
            overflow: "auto",
            backgroundColor: "white",
            borderRadius: "8px",
            borderTop: "1px solid lightgrey",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ flexGrow: "1" }}>
            <StepComponent
              formValues={formValues}
              handleChange={handleChange}
            />
          </div>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              pt: 2,
              gap: "1rem",
            }}
          >
            <Button
              // color="inherit"
              onClick={handleBack}
              sx={{ mr: 1, display: activeStep === 0 ? "none" : "" }}
              startIcon={<KeyboardArrowLeftIcon />}
            >
              {t("to")} {t(steps[activeStep - 1])}
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button
              // color="inherit"
              onClick={handleNext}
              sx={{ mr: 1, display: isLastStep() ? "none" : "" }}
              endIcon={<KeyboardArrowRightIcon />}
            >
              {t("to")} {t(steps[activeStep + 1])}
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          pt: 2,
          gap: "1rem",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            // pt: 2,
            gap: "1rem",
          }}
        >
          {!isMobile && (
            <Button
              variant="text"
              onClick={handleDiscard}
              startIcon={<CloseIcon />}
            >
              {t("discard")}
            </Button>
          )}
          {modeOptions.ADD_POLYGON.length === 0 && (
            <Tooltip title={getShortcutLabel(deleteKey)}>
              <Button
                variant="contained"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleDelete}
              >
                {t("delete")}
              </Button>
            </Tooltip>
          )}
          <Tooltip
            title={
              !isValidPolygonForProject(editedGeometry)
                ? t("invalid_geometry")
                : !hasFormChanged && !editedGeometry
                  ? t("no_changes_made")
                  : getShortcutLabel(saveKey)
            }
          >
            <span>
              <Button
                variant="contained"
                onClick={handleConfirmSave}
                disabled={
                  !isValidPolygonForProject(editedGeometry) ||
                  (!hasFormChanged && !editedGeometry)
                }
                startIcon={<SaveIcon />}
              >
                {t("save")}
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
});

/**
 * Verifica si la geometría es un polígono válido para el proyecto.
 * Acepta:
 * ✅ Un solo punto (single point)
 * ✅ Un solo polígono sin huecos internos.
 * ✅ Un solo polígono con huecos internos.
 * ❌ No permite multipolígonos con polígonos aislados.
 *
 * @param {Array} coordinates - Lista de anillos del polígono en formato OpenLayers.
 * @returns {boolean} - True si la geometría es válida, False si tiene múltiples polígonos aislados.
 */
function isValidPolygonForProject(feature) {
  const coordinates = feature?.geometry?.coordinates;

  // Para cuando no se ha editado la geometría (coordinates === null)
  if (!coordinates) return true;

  if (!Array.isArray(coordinates) || coordinates.length === 0) {
    return false; // No es un polígono válido
  }
  // 📌 Verificar si es un único punto
  // if (coordinates.length === 1 && isPoint(coordinates[0])) {
  if (isPoint(coordinates)) {
    return true; // Es un punto válido
  }

  // Determinar cuál es el anillo exterior basándonos en el área
  let exteriorRing = coordinates.reduce((largest, ring) => {
    return polygonArea(ring) > polygonArea(largest) ? ring : largest;
  });

  // Comprobar si los demás anillos están dentro del exterior
  for (const ring of coordinates) {
    if (ring !== exteriorRing && !isRingInsidePolygon(ring, exteriorRing)) {
      return false; // Encontramos un anillo que no está contenido -> Multipolígono inválido
    }
  }

  return true; // Todos los anillos internos están dentro del exterior -> Válido
}

/**
 * Comprueba si la entrada es un punto (single point)
 * @param {Array} coordinates - Coordenadas a verificar
 * @returns {boolean} - True si es un punto, false si no lo es
 */
function isPoint(coordinates) {
  return (
    Array.isArray(coordinates) &&
    coordinates.length === 2 &&
    typeof coordinates[0] === "number" &&
    typeof coordinates[1] === "number"
  );
}

/**
 * Comprueba si un anillo está completamente contenido dentro de otro polígono
 * @param {Array} innerRing - Coordenadas del anillo interno
 * @param {Array} outerRing - Coordenadas del polígono exterior
 * @returns {boolean} - True si el anillo está dentro del polígono, false si no lo está
 */
function isRingInsidePolygon(innerRing, outerRing) {
  if (
    !innerRing ||
    !outerRing ||
    innerRing.length === 0 ||
    outerRing.length === 0
  ) {
    return false;
  }

  return innerRing.every(([x, y]) => pointInPolygon(x, y, outerRing));
}

/**
 * Comprueba si un punto está dentro de un polígono usando el algoritmo de cruce de rayos
 * @param {number} x - Coordenada X del punto
 * @param {number} y - Coordenada Y del punto
 * @param {Array} polygon - Coordenadas del polígono
 * @returns {boolean} - True si el punto está dentro, false si está fuera
 */
function pointInPolygon(x, y, polygon) {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0],
      yi = polygon[i][1];
    const xj = polygon[j][0],
      yj = polygon[j][1];

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

/**
 * Calcula el área de un polígono usando la fórmula de Shoelace
 * @param {Array} polygon - Coordenadas del polígono
 * @returns {number} - Área absoluta del polígono (sin importar la dirección de los puntos)
 */
function polygonArea(polygon) {
  let area = 0;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];
    area += (xj + xi) * (yj - yi);
  }
  return Math.abs(area) / 2;
}
